import { UserSearch } from 'lucide-react';
import type { Ask } from '@ah/asks/shared';

export type { Ask } from '@ah/asks/shared';

export const canYouHelpQuestion = 'Do you know anyone who might be interested?';

function stripWantedPrefix(title: string): string {
  return title.replace(/^\s*wanted\s*:\s*/i, '').trim();
}

export function CanYouHelpCard({ item }: { item: Ask }): JSX.Element {
  const headline = stripWantedPrefix(item.shortTitle);
  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="flex flex-col items-center text-center gap-2 px-5 pt-6">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center text-primary">
          <UserSearch className="w-7 h-7" strokeWidth={1.8} />
        </div>
      </div>
      <div className="px-5 pt-4 pb-2 space-y-2">
        <p className="font-bold text-xl leading-tight text-foreground">
          Wanted: {headline}
        </p>
        <p className="text-[15px] text-foreground/85 leading-relaxed">
          {item.description}
        </p>
      </div>
      <div className="px-5 pb-5 pt-2">
        <p className="text-[11px] text-muted-foreground/80">
          From {item.godmother.firstName}, Chief Underling
        </p>
      </div>
    </div>
  );
}
